'use client'

import {
  Flex,
  Container,
  Heading,
  Stack,
  Text,
  Button,
  Icon,
  IconProps,
  Image,
  HStack,
} from '@chakra-ui/react'
import { Helmet } from 'react-helmet'



export default function FeaturesPage() {
  return (
    <><Helmet>
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4998506487825842"
        crossOrigin="anonymous"></script>
      <title>Headsup Chrome Extension App | Feature Showcase</title>
      <meta name="description" content="Headsup Features"/>
    </Helmet><Container maxW={'5xl'}>
        <Stack
          textAlign={'center'}
          align={'center'}
          spacing={{ base: 8, md: 10 }}
          py={{ base: 20, md: 28 }}>
          <Heading
            fontWeight={600}
            fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}>
            Bookmark Managing{' '}
            <Text as={'span'} color={'orange.400'}>
              made easy
            </Text>
          </Heading>
          <Text color={'gray.500'} maxW={'3xl'}>
            HeadsUp is a suite of Bookmark and links managing App, you can search, select a text and categorize, move your bookmarks. You can add some ToDos
            also create a collection of links using Linklist Feature
          </Text>
          <Text m={2} fontWeight={"extrabold"} align={"center"}>You will find our key features Below</Text>
          <Flex w={'full'}>
            <Image
              boxSize={"full"}
              src="https://res.cloudinary.com/docn0mvoh/image/upload/v1708858727/key-features_eedyxu.jpg"
              alt="Key features" />
          </Flex>
          <Flex direction={{base:"column", md:"row"}} alignItems={"center"}>
            <Flex width={{ base: "100%", md: "50%" }} direction="column">
              <Image
                m={2}
                objectFit="fill"
                borderRadius={"lg"}
                boxShadow="2xl"
                height={"250px"}
                src="https://res.cloudinary.com/docn0mvoh/image/upload/v1708829260/gif-context-menu_aswlo0.gif"
                alt="" />
              <Text
                p={4}
                fontWeight={"black"}
                fontSize={"18px"}
                align={"center"}
              >
                Highlight Words
              </Text>
              <Text fontSize={"12px"} fontWeight={"black"} align={"center"}>
                On Any website select any phrase which will make you to open
                that link later
              </Text>
            </Flex>
            <Flex width={{ base: "100%", md: "50%" }} direction="column">
              <Image
                m={2}
                objectFit="fill"
                borderRadius={"lg"}
                boxShadow="2xl"
                height={"250px"}
                src="https://res.cloudinary.com/docn0mvoh/image/upload/v1708829260/gif-show-category-view_lrrfkx.gif"
                alt="" />
              <Text
                p={4}
                fontWeight={"black"}
                fontSize={"18px"}
                align={"center"}
              >
                Categorized Bookmark View
              </Text>
              <Text fontSize={"12px"} fontWeight={"black"} align={"center"}>
                Bookmark as much as you want under any category that you
                create using Add + and view the links here
              </Text>
            </Flex>

          </Flex>
          <Flex direction={{base:"column", md:"row"}} alignItems={"center"}>
            <Flex width={{ base: "100%", md: "50%" }} direction="column">
              <Image
                m={2}
                objectFit="fill"
                borderRadius={"lg"}
                boxShadow="2xl"
                height={"250px"}
                src="https://res.cloudinary.com/docn0mvoh/image/upload/v1708829261/gif-move-tasks_pjopqw.gif"
                alt="" />
              <Text
                p={4}
                fontWeight={"extrabold"}
                fontSize={"18px"}
                align={"center"}
              >
                Move the task between columns
              </Text>
              <Text fontSize={"12px"} fontWeight={"black"} align={"center"}>
                Move to Remind Me, to get a weekly reminder, make your new tab
                your personal Jira
              </Text>
            </Flex>
            <Flex width={{ base: "100%", md: "50%" }} alignItems={"center"} direction="column">
              <Image
                m={2}
                objectFit="fill"
                borderRadius={"lg"}
                boxShadow="2xl"
                height={"250px"}
                src="https://res.cloudinary.com/docn0mvoh/image/upload/v1708829260/gif-linklist-explaination_iifqjq.gif"
                alt="" />
              <Text
                p={4}
                fontWeight={"black"}
                fontSize={"18px"}
                align={"center"}
              >
                Linklist - New Era!
              </Text>
              <Text fontSize={"12px"} fontWeight={"black"} align={"center"}>
                Create a colleciton of links and share with your peers like
                you do the playlist, open the link and have your own WebPage
              </Text>
            </Flex>
          </Flex>
        </Stack>
      </Container></>
  )
}